/** @format */

import type { RootState } from "../store/store";

export const selectCollectSubscription = (state: RootState) =>
    state.collectBilling.subscription;

export const selectCollectSubscriptionLoading = (state: RootState) =>
    state.collectBilling.isLoading;

export const selectCollectSubscriptionError = (state: RootState) =>
    state.collectBilling.error;

export const selectCollectBillingSubmitting = (state: RootState) =>
    state.collectBilling.isSubmitting;

export const selectCollectBillingSubmitError = (state: RootState) =>
    state.collectBilling.submitError;

export const selectCollectBillingRequiresAction = (state: RootState) =>
    state.collectBilling.requiresAction;

export const selectCollectBillingClientSecret = (state: RootState) =>
    state.collectBilling.clientSecret;

// ── Access (Story 5) ─────────────────────────────────────────────────────

export const selectCollectAccess = (state: RootState) =>
    state.collectBilling.access;

/** True when the current principal may use premium Collect features now. */
export const selectCollectHasAccess = (state: RootState) =>
    state.collectBilling.access?.hasAccess ?? true;

export const selectCollectIsSuperAdmin = (state: RootState) =>
    state.collectBilling.access?.isSuperAdmin ?? false;

export const selectCollectIsTrialing = (state: RootState) =>
    state.collectBilling.access?.isTrialing ?? false;

export const selectCollectTrialDaysRemaining = (state: RootState) =>
    state.collectBilling.access?.trialDaysRemaining;
